import MapTypeStyle = google.maps.MapTypeStyle;
import MapTypeStyler = google.maps.MapTypeStyler;

const stylersToString = (stylers: MapTypeStyler) =>
    Object.entries(stylers)
        .map(([key, value]) => `${key}:${value.replace('#', '0x')}`)
        .join('|');

const styleToString = ({ elementType, featureType, stylers }: MapTypeStyle, isFirst: boolean) => {
    const stylesString = !isFirst ? 'style=' : '';
    const featureString = featureType ? `feature:${featureType}|` : '';
    const elementString = elementType ? `element:${elementType}|` : '';
    const stylersString = stylers ? stylersToString(stylers[0]) : '';

    return encodeURI(`${stylesString}${featureString}${elementString}${stylersString}`);
};

export const stylesToString = (styles: MapTypeStyle[]) =>
    styles.map((style, index) => styleToString(style, index === 0)).join('&');

/*
    note: This currently only supports 1 styler object per style. It should cover most of the use cases.
    result format: style=feature:myFeatureArgument|element:myElementArgument|myRule1:myRule1Argument|myRule2:myRule2Argument&style2=...
    The first 'style=' is added by the package
*/
